import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getCallSettings } from './getCallSettings';
import { getCustomSettings } from './getCustomSettings';
import { getDirectionSettings } from './getDirectionSettings';
import { getDiscordSettings } from './getDiscordSettings';
import { getEmailSettings } from './getEmailSettings';
import { getFacebookSettings } from './getFacebookSettings';
import { getGoogleMapsSettings } from './getGoogleMapsSettings';
import { getInstagramSettings } from './getInstagramSettings';
import { getKakaoTalkSettings } from './getKakaoTalkSettings';
import { getLineSettings } from './getLineSettings';
import { getRumbleTalkSettings } from './getRumbleTalkSettings';
import { getSaveContactSettings } from './getSaveContactSettings';
import { getSMSSettings } from './getSMSSettings';
import { getSnapchatSettings } from './getSnapchatSettings';
import { getTelegramSettings } from './getTelegramSettings';
import { getTwitterSettings } from './getTwitterSettings';
import { getViberSettings } from './getViberSettings';
import { getWeChatSettings } from './getWeChatSettings';
import { getWhatsAppSettings } from './getWhatsAppSettings';

export const channelSettingsGetters: Record<
  ChatsChannelType,
  (channel: Partial<ChatsChannelBase>) => ChatsChannelSetting | null
> = {
  [ChatsChannelType.whatsapp]: getWhatsAppSettings,
  [ChatsChannelType.facebook]: getFacebookSettings,
  [ChatsChannelType.instagram]: getInstagramSettings,
  [ChatsChannelType.telegram]: getTelegramSettings,
  [ChatsChannelType.viber]: getViberSettings,
  [ChatsChannelType.line]: getLineSettings,
  [ChatsChannelType.discord]: getDiscordSettings,
  [ChatsChannelType.call]: getCallSettings,
  [ChatsChannelType.custom]: getCustomSettings,
  [ChatsChannelType.email]: getEmailSettings,
  [ChatsChannelType.getdirection]: getDirectionSettings,
  [ChatsChannelType.googlemaps]: getGoogleMapsSettings,
  [ChatsChannelType.kakaotalk]: getKakaoTalkSettings,
  [ChatsChannelType.rumbletalk]: getRumbleTalkSettings,
  [ChatsChannelType.sms]: getSMSSettings,
  [ChatsChannelType.snapchat]: getSnapchatSettings,
  [ChatsChannelType.twitter]: getTwitterSettings,
  [ChatsChannelType.wechat]: getWeChatSettings,
  [ChatsChannelType.savecontact]: getSaveContactSettings
};

export * from './useChannelSettings';
